import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Base } from './Base.js';
import * as utils from './utils.js';
export var Reserved = /*#__PURE__*/function (_Base) {
  _inherits(Reserved, _Base);
  function Reserved(type) {
    var _this;
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    _classCallCheck(this, Reserved);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Reserved).call(this));
    _this.type = type;
    _this.count = count;
    return _this;
  }
  _createClass(Reserved, [{
    key: "decode",
    value: function decode(stream, parent) {
      stream.pos += this.size(null, parent);
      return undefined;
    }
  }, {
    key: "size",
    value: function size(data, parent) {
      var count = utils.resolveLength(this.count, null, parent);
      return this.type.size() * count;
    }
  }, {
    key: "encode",
    value: function encode(stream, val, parent) {
      return stream.fill(0, this.size(val, parent));
    }
  }]);
  return Reserved;
}(Base);